module.exports = __webpack_public_path__ + "img/green_027.93a8dd10.png";